'use strict';

function getOverlayAnchor($asset) {
    var $customAnchor = $asset.find('.promo-overlay-container').first();

    if ($customAnchor.length) {
        return $customAnchor;
    }

    return $asset.find('.asset-image_container').first();
}

function isSlickOverlay($asset) {
    return $asset.hasClass('slide');
}

function prepareAnchor($anchor) {
    if (!$anchor.length) {
        return;
    }

    $anchor.addClass('promo-bil-overlay-anchor');

    if ($anchor.hasClass('promo-overlay-container')) {
        var $anchorParent = $anchor.parent();

        if ($anchorParent.length && $anchorParent.css('position') === 'static') {
            $anchorParent.css('position', 'relative');
        }
    }

    if ($anchor.css('position') === 'static') {
        $anchor.css('position', 'relative');
    }
}

function moveAssetOverlay(_, asset) {
    var $asset = $(asset);
    var $overlayContainer = $asset.children('.promo-bil-overlay-container').first();
    var $overlays;
    var $anchor = getOverlayAnchor($asset);
    var wasRelocated = false;

    if (!$overlayContainer.length) {
        return;
    }

    $overlays = $overlayContainer.children('.promo-bil-overlay');

    if (!$overlays.length) {
        return;
    }

    $overlays.each(function eachOverlay(__, overlay) {
        var $overlay = $(overlay);
        var $target = isSlickOverlay($asset) ? $overlayContainer : $anchor;

        if (!$target.length) {
            return;
        }

        prepareAnchor($target);

        if (!$overlay.parent().is($target)) {
            $overlay.appendTo($target);

            if (!$target.is($overlayContainer)) {
                wasRelocated = true;
            }
        }
    });

    if (wasRelocated) {
        $overlayContainer.addClass('promo-bil-overlay-container--relocated');
    }
}

exports.init = function init() {
    $('.asset.promo-bil-overlay-active').each(moveAssetOverlay);
};
